import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Input } from 'antd';
import { HomeOutlined, SearchOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useAuth } from '../AuthContext';

const t = {
  ar: {
    code: '404',
    title: 'الصفحة غير موجودة',
    body: 'يبدو أن الرابط لا يعمل أو أن الصفحة تم نقلها. جرّب البحث عن خدمة أو العودة للرئيسية.',
    searchPh: 'ابحث عن خدمة... مثال: تصميم شعار',
    home: 'الصفحة الرئيسية',
    browseGigs: 'تصفح الخدمات',
    browseFreelancers: 'ابحث عن مستقلين',
    backArrow: <RightOutlined />,
  },
  en: {
    code: '404',
    title: 'Page not found',
    body: "Looks like the link is broken or the page was moved. Try searching or head back to the homepage.",
    searchPh: 'Search a service... e.g. Logo design',
    home: 'Home',
    browseGigs: 'Browse services',
    browseFreelancers: 'Find freelancers',
    backArrow: <LeftOutlined />,
  },
};

export default function NotFound({ lang: langProp }) {
  const auth = useAuth() || {};
  const lang = langProp || auth.lang || 'ar';
  const tx = t[lang] || t.ar;
  const navigate = useNavigate();
  const [q, setQ] = React.useState('');

  const search = () => {
    const term = (q || '').trim();
    navigate(term ? `/search?q=${encodeURIComponent(term)}` : '/search');
  };

  return (
    <div className="error-page" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <div className="error-card glass-strong animate-pop">
        <div className="error-code grad-text">{tx.code}</div>
        <h1 className="error-title">{tx.title}</h1>
        <p className="error-body">{tx.body}</p>

        <div className="error-search">
          <Input.Search
            size="large"
            placeholder={tx.searchPh}
            prefix={<SearchOutlined />}
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onSearch={search}
            enterButton
          />
        </div>

        <div className="error-actions">
          <Link to="/"><Button type="primary" size="large" icon={<HomeOutlined />}>{tx.home}</Button></Link>
          <Link to="/gigs"><Button size="large">{tx.browseGigs}</Button></Link>
          <Link to="/freelancers"><Button size="large">{tx.browseFreelancers}</Button></Link>
        </div>
      </div>
    </div>
  );
}
